import React, {memo} from 'react'
import {Grid, Header, Message} from 'semantic-ui-react'
import {ChangePassword} from './change-password'
import {withErrorHandling, withHelmet, withMeData, withPropsPresent} from '../../hoc'

const _AcceptInvitation = (
  {
    me,
    navigate
  }
) => {

  const onChanged = () => {
    navigate('/c/services')
  }

  return (
    <Grid centered doubling columns={2}>
      <Grid.Row columns={2}>
        <Grid.Column width='6'>
          <Header as='h1'>Accept Invitation</Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column width='6'>
          <Message header='Welcome!'
                   content={`This is an invitation to the account: ${me.activeAccount.name}. Please set your password to continue`}/>
          <ChangePassword onChanged={onChanged} onChangeText='Proceed'/>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

let AcceptInvitation = (props) => {
  return (<_AcceptInvitation {...props}/>)
}

AcceptInvitation = withHelmet(AcceptInvitation, 'Set Password')
AcceptInvitation = withPropsPresent(AcceptInvitation, ['me'])
AcceptInvitation = withMeData(AcceptInvitation)
AcceptInvitation = withErrorHandling(AcceptInvitation)
AcceptInvitation = memo(AcceptInvitation)

export {AcceptInvitation, _AcceptInvitation}

export default AcceptInvitation